import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type AddonsRule } from 'niara-spear-crudmodel';
import callApi from '@niarab2c/frontend-commons/src/util/callApi';
import { CompleteRootState } from '../../base';
import addonSearchReducer, { AddonSearchState } from './addonSearch';
export * from './addonSearch';
export type AddonState = {
  searches: Record<string, AddonSearchState>;
  addonsRule: AddonsRule;
};

/**
 * @deprecated Substituir por Rules.loadRules
 */
export const loadAddonsRule = createAsyncThunk<AddonsRule, {
  clientId?: string;
  propertyId?: string;
} | void, {
  state: CompleteRootState;
}>('addon/loadAddonsRule', async (options, {
  getState
}) => {
  if (!options) {
    // só para ajudar no typing
    options = {};
  }

  // Agora com a unificação pego o clientId do hotelSeach ou do core
  const clientId = getState().core?.clientId ?? getState().quotation?.quotation?.clientId ?? getState().shoppingCart?.clientId ?? getState().authentication?.user?.clientId ?? options?.clientId;
  const shoppingCart = getState().shoppingCart;
  const isLoyaltyOptIn = shoppingCart?.items?.some(item => item?.loyaltyOptInRoomRateId) && shoppingCart?.isLoyaltyOptIn;
  const propertyId = options ? options?.propertyId : undefined;
  const isForGroups = getState()?.hotel?.isForGroups;
  const landingPageId = getState().storefrontConfig?.storefront?.landingPageId;
  const rulesContext = {
    clientId,
    landingPageId,
    isForGroups,
    isLoyaltyOptIn,
    propertyId
  }; // TODO complementar o contexto com mais dados (hotel, data, etc)

  const results = await callApi('niara-spear-commons', `/genericRuleResolver/details`, 'get', {
    params: rulesContext
  });
  return results?.addonsRule;
});
const slice = createSlice({
  name: 'addon',
  initialState: {} as AddonState,
  reducers: {
    clearSearch: (state, action: PayloadAction<{
      searchId: string;
    }>) => {
      const searchId = action?.payload?.searchId;
      if (state?.searches?.[searchId]) {
        return {
          ...state,
          searches: {
            ...state.searches,
            [searchId]: undefined
          }
        };
      }
      return state;
    }
  },
  extraReducers(builder) {
    builder.addCase(loadAddonsRule.fulfilled, (state, action) => {
      if (action.payload) state.addonsRule = action.payload;
    }).addMatcher(action => action.type?.startsWith('addonSearch') && action.type.includes('pending'), (state, action) => {
      const searchId = action.meta.arg.searchId ?? action.meta.requestId;
      if (searchId) {
        const currentState: AddonSearchState = state?.searches?.[searchId] ?? {
          searchId
        };
        currentState.inProgress = true;
        const newSearches = {
          ...state.searches,
          [searchId]: currentState
        };
        return {
          ...state,
          searches: newSearches
        };
      }
    }).addMatcher(action => action.type?.startsWith('addonSearch') && !action.type.includes('pending'), (state, action) => {
      const searchId = action?.['payload']?.['searchId'];
      if (searchId) {
        const currentState: AddonSearchState = state?.searches?.[searchId] ?? {
          searchId
        };
        const newState = addonSearchReducer(currentState, action);
        const newSearches = Object.assign({}, ...[state?.searches, {
          [searchId]: newState
        }].filter(Boolean));
        return {
          ...state,
          searches: newSearches
        };
      }
      return state;
    });
  }
});
export const {
  clearSearch
} = slice.actions;
const reducer = slice.reducer;
export default reducer;